import { axios } from "~/plugins/request";

export const state = () => {
  return {};
};
export const mutations = {};
export const actions = {
  findAllProvince({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`/report/smartReport/findAllProvince`).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  findAllBatchByProvinceId({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/report/smartReport/findAllBatchByProvinceId`, { params }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  generationScheme({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/report_v2/plan/aiGenerateScheme`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  findAllSpecialityCategoryAndSpeciality({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/report/smartReport/findAllSpecialityCategoryAndSpeciality`, {
        params
      }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },

  getOccupationOptions({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/report/smartReport/occupation`, { params }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  }
};
